import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";

export const ProductionAndSalesDetailSalary = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"salary"}>
                <NFLookupUnit title={t("Unit")} fieldName="unitId" />
                <NFLookupProduct title={t("Job")} fieldName="jobId" />
                <NFIntInput title={t("Quantity")} fieldName="quantity" />
                <NFIntInput title={t("Price")} fieldName="price" />
                <NFIntInput title={t("Amount")} fieldName="amount" />
                <NFLookupAccount title={t("Account")} fieldName="accountId" />
                <NFLookupProduct title={t("Product")} fieldName="productId" />
            </NFormTable>
        </>
    );
};
